import React from 'react'
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';
import { Marker } from '@react-google-maps/api';
import houseIcon from '../images/Icons/home-solid.png'
import officeIcon from '../images/Icons/office-icon.png'

const containerStyle = {
  width: '100%',
  height: '100%'
};

let center = {
    lat: 32.80650247906792, 
    lng: -96.80437415772697
};

let zoom = 12;

function Mymap(props) {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: "AIzaSyBaQvLpKaTwTdMtcvnyLMfSu5P7HzVnbek"
  })

  const [map, setMap] = React.useState(null)

  const markerLocations = props.properties;

  const onLoad = React.useCallback(function callback(map) {  
    setMap(map)
  }, [])

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null)
  }, [])

  if (markerLocations.length === 1) {
    center = markerLocations[0].node.address;
    zoom = 10;
  }

  if (props.contact) {
    center = {
      lat: 32.91145433468429, 
      lng: -96.87683457028507
    }
    zoom = 12
  }


  return isLoaded ? (
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={zoom}
        onLoad={onLoad}
        onUnmount={onUnmount}
      >
        { /* Child components, such as markers, info windows, etc. */ }
        {markerLocations.map( (edge,i) => {
          return <Marker key={i} icon={houseIcon} onClick={() => props.handleClick(edge.node)} position={edge.node.address}></Marker>
        })}

        { props.contact && <Marker icon={officeIcon} position={center}></Marker> }
        <></>
      </GoogleMap>
  ) : <></>
}

export default React.memo(Mymap)